module.exports = __webpack_public_path__ + "img/icon-ecosystem-white.ef9deded.svg";